import { CellInfo } from '../useTable.js';

export const defaultRowClassFn = (rowNumber: number, totalRows: number): string => {
  const allRows = 'ScrollTable-table-row u-table-row-pB-xxs u-table-row-pT-xxs u-table-row-pL-0 u-table-row-pR-0';
  if (rowNumber === 0) {
    /** Header */
    return `${allRows} u-table-row-bg-grey`;
  }
  if (rowNumber === 1) {
    /** Section (axisX: Category | axisY: dataSet) Start */
    return `${allRows} u-table-row-pT-sm`;
  }
  if (rowNumber === totalRows - 1) {
    /** Section (axisX: Category | axisY: dataSet) End */
    return `${allRows} u-table-row-pB-sm`;
  }
  /** Everything else */
  return `${allRows}`;
};

export const getDefaultCellClassNames = (c: CellInfo): string => {
  return `row-${c.rowN} col-${c.colN}`;
};
